import React, { Fragment, useState } from "react";
import { auth } from "./firebase";
import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.css";

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const signInWithEmailAndPasswordHandler = (event, email, password) => {
    event.preventDefault();
    auth
      .signInWithEmailAndPassword(email, password)
      .catch((error) => {
        setError(error.message);
        alertifyS();
      });
  };

  const alertifyS = () => {
    if (error !== null) {
      alertify.defaults.theme.ok = "btn btn-dark";
      alertify.alert("Access Denied c", error);
    }
  };

  const onChangeHandler = (event) => {
    const { name, value } = event.currentTarget;

    if (name === "userEmail") {
      setEmail(value);
    } else if (name === "userPassword") {
      setPassword(value);
    }
  };

  return (
     <Fragment>
        <div class="container">
           <div class="row">
              <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
                 <div class="card border-0 shadow rounded-3 my-5">
                    <div class="card-body p-4 p-sm-5">
                       <h5 class="card-title text-center mb-5 fw-light fs-5 bubblegum">Frivle Admin</h5>
                       <form>
                          <div class="form-floating mb-3">
                             <label for="userEmail">Email :</label>
                             <input type="email" name="userEmail" className="form-control" id="userEmail" value={email} placeholder="Email" onChange={(event) => onChangeHandler(event)} />
                          </div>
                          <div class="form-floating mb-3">
                             <label for="userPassword">Şifre :</label>
                             <input type="password" name="userPassword" className="form-control " id="userPassword" value={password} placeholder="Şifre" onChange={(event) => onChangeHandler(event)}/>
                          </div>
                          <div class="d-grid">
                             <button className="btn btn-primary btn-login text-uppercase" onClick={(event) => { signInWithEmailAndPasswordHandler(event, email, password); }} >
                             Giriş Yap
                             </button>
                          </div>
                       </form>
                    </div>
                 </div>
              </div>
           </div>
        </div>
     </Fragment>
  );
};
export default SignIn;
